// The tile a build tool acts on: step at most `reach` world units from (px,py) toward the
// aim point (ax,ay) and take the tile there. Shared by the server (which does the edit in
// the build/mine behaviours) and the client (which previews it as a ghost outline), so the
// dashed box the player sees is exactly the tile that will change.

import { tileX, tileY } from "./chunks.js";

export const DEFAULT_REACH = 150;

export function reachTile(px, py, ax, ay, reach = DEFAULT_REACH) {
    const dx = ax - px, dy = ay - py;
    const d = Math.hypot(dx, dy) || 1;
    const rr = Math.min(d, reach);
    return { tcx: tileX(px + (dx / d) * rr), tri: tileY(py + (dy / d) * rr) };
}
